import { render, staticRenderFns } from "./retentionChange.vue?vue&type=template&id=0526ce5b&scoped=true&"
import script from "./retentionChange.vue?vue&type=script&lang=js&"
export * from "./retentionChange.vue?vue&type=script&lang=js&"
import style0 from "./retentionChange.vue?vue&type=style&index=0&id=0526ce5b&prod&lang=scss&scoped=true&"
import style1 from "./retentionChange.vue?vue&type=style&index=1&id=0526ce5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526ce5b",
  null
  
)

export default component.exports